import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeePayrollsProcess.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { toWords } from 'number-to-words';
import fgIdentitySolutions from '../../../assets/Images/fgIdentitySolutions.jpg';
import { capitalizeFirstLetter } from '../../../utils/validations';
const EmployeePayrollsProcess = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [designation, setDesignation] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [employee, setEmployee] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const dateInputRef = useRef(null);
    const [toDate, setToDate] = useState("");

    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        designation: false,
        fromDate: false,
        employee: false,
        toDate: false,
    });
    const [errors, setErrors] = useState({});
    const [designationData, setDesignationData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && district && fromDate && employee && toDate;


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`
                );
                setStateOptions(
                    response.data.map(item => ({
                        value: item.id,
                        label:capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        fetchStates();
    }, []);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`
                    );
                    setDistrictOptions(
                        response.data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);

    // Fetch employees when district changes
    useEffect(() => {
        if (district) {
            const fetchEmployee = async () => {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/api/employee-posting/by-district/${district}`
                    );
                    setEmployeeOptions(
                        response.data.map(emp => ({
                            value: emp.employeeId,
                            label: `${emp.fullName} - ${emp.employeeId}`,

                            designation: emp.designation,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching employees:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load employees' }));
                }
            };
            fetchEmployee();
        } else {
            setEmployeeOptions([]);
            setEmployee(null);
        }
    }, [district]);

    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, designation, year, employee]); // ✅ Add employee to depende

    const handleInputChange = (selectedOption, field) => {
        switch (field) {
            case 'state':
                setState(selectedOption ? selectedOption.value : null);
                setDistrict(null);
                setDesignation(null);
                setEmployee(null);
                break;
            case 'district':
                setDistrict(selectedOption ? selectedOption.value : null);
                setEmployee(null);
                break;
            case 'designation':
                setDesignation(selectedOption ? selectedOption.value : '');
                break;
            case 'employee':
                setEmployee(selectedOption ? selectedOption.value : null);

                // Automatically set designation from selected employee
                if (selectedOption) {
                    const emp = employeeOptions.find(emp => emp.value === selectedOption.value);
                    setDesignation(emp ? emp.designation : ''); // auto-fill designation
                } else {
                    setDesignation('');
                }
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };




    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!district) newErrors.district = 'District is required';
        if (!designation) newErrors.designation = 'Month is required';
        if (!employee) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // const handleGenerateReport = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm()) return;

    //     try {
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_API_BASE_URL}/api/salary-structure/filter`,
    //             {
    //                 params: {
    //                     stateId: state,
    //                     //districtId: district,
    //                     //designation,
    //                     startDate: fromDate,
    //                     endDate: toDate,
    //                     employeeId: employee

    //                 },
    //             }
    //         );

    //         // Extracting employeeWiseReport
    //         const employeeData = response.data.employeeWiseReport || [];
    //         const designationWise = response.data.designationWiseReport || [];
    //         const initializedData = employeeData.map((item) => ({
    //             ...item,
    //             casualLeave: item.casualLeave || 0,
    //             absentDays: item.absentDays || 0,
    //         }));

    //         setAttendanceData(initializedData);
    //         setDesignationData(designationWise);
    //         // alert("Attendance data fetched successfully!");
    //     } catch (error) {
    //         console.error("Error fetching report data:", error);
    //         setErrors((prev) => ({
    //             ...prev,
    //             general: "Failed to fetch report data",
    //         }));
    //         alert("Failed to fetch report data. Please try again.");
    //     }
    // };

    const handleGenerateReport = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/salary-structure/filter`,
                {
                    params: {
                        stateId: state,
                        // districtId: district,
                        employeeId: employee,
                        startDate: fromDate,
                        endDate: toDate,
                    },
                }
            );

            // Some APIs return { employeeWiseReport: [...] }, some just return [...]
            const employeeData = Array.isArray(response.data)
                ? response.data
                : response.data.employeeWiseReport || [];

            const initializedData = employeeData.map((item) => ({
                ...item,
                casualLeave: item.casualLeave || 0,
                absentDays: item.absentDays || 0,
            }));

            setAttendanceData(initializedData);
        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const formatNumber = (value) => {
        if (typeof value === "number" && value >= 1000) {
            return value.toLocaleString("en-IN"); // en-US or en-IN depending on your format
        }
        return value;
    }
    const downloadPDF = () => {
        const doc = new jsPDF("p", "pt", "a4");

        // Helper function to format date
        const formatDate = (dateString) => {
            if (!dateString) return "";
            const d = new Date(dateString);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        };


        attendanceData.forEach((emp, index) => {
            if (index !== 0) doc.addPage();
            const headerText = `PAYSLIP  ${monthNames[emp.month - 1]}-${emp.year}`;

            doc.setFontSize(18);
            doc.setFont("helvetica", "bold");

            // Left side text
            doc.text(headerText, 40, 50);

            // Company Info
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.text("4G Identity Solutions Pvt Ltd.", 40, 70);
            doc.text("Flot No.280, Road No.78, Jubilee Hills,", 40, 82);
            doc.text("Hyderabad, Telangana - 500033", 40, 94);

            // Right side logo
            doc.addImage(fgIdentitySolutions, "JPEG", 430, 20, 100, 80);

            // ============================
            // Selected Filters Section
            // ============================
            // doc.setFontSize(12);
            // doc.setFont("helvetica", "bold");
            // doc.text("Report Filters:", 40, 120);

            // doc.setFontSize(10);
            // doc.setFont("helvetica", "normal");
            // doc.text(`State: ${stateOptions.find(opt => opt.value === state)?.label || "-"}`, 40, 135);
            // doc.text(`District: ${districtOptions.find(opt => opt.value === district)?.label || "-"}`, 40, 150);
            // doc.text(`Employee: ${employeeOptions.find(opt => opt.value === employee)?.label || "-"}`, 40, 165);
            // doc.text(`Designation: ${designation || "-"}`, 40, 180);
            // doc.text(`From Date: ${formatDate(fromDate)}`, 40, 195);
            // doc.text(`To Date: ${formatDate(toDate)}`, 40, 210);

            // ============================
            // Employee Name
            // ============================
            doc.setFontSize(14);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);
            doc.text(emp.fullName || "Employee", 40, 140);
            // doc.text(`${monthNames[emp.month - 1]}-${emp.year}`, 400, 140); // right side
            doc.setLineWidth(0.5); // thickness of the line
            doc.line(40, 145, 550, 145); // from left (40) to right (550) at y=145
            // Define common column widths
            const columnStyles = {
                0: { cellWidth: 120 },
                1: { cellWidth: 120 },
                2: { cellWidth: 140 },
                3: { cellWidth: 130 },
            };

            // Employee Info Table
            doc.autoTable({
                startY: 145,
                head: [["Employee Number", "Date Joined", "Location", "Designation"]],
                body: [[emp.employeeId, emp.joiningDate, emp.districtName || '-', emp.designation]],
                headStyles: { fillColor: false, textColor: [128, 128, 128], fontStyle: "bold" },
                bodyStyles: { fillColor: false, textColor: [0, 0, 0] },
                columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // Bank Info Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY,
                head: [["Bank", "IFSC Code", "Account Number", "Payment Mode"]],
                body: [[emp.bankName, emp.ifscCode, emp.accountNumber, "Bank Transfer"]],
                headStyles: { fillColor: false, textColor: [128, 128, 128], fontStyle: "bold" },
                bodyStyles: { fillColor: false, textColor: [0, 0, 0] },
                columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // IDs Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY,
                head: [["PAN", "UAN", "Member ID", "ESIC No"]],
                body: [[emp.panNumber, emp.uanNumber, emp.memberId, emp.esiNumber]],
                headStyles: { fillColor: false, textColor: [128, 128, 128], fontStyle: "bold" },
                bodyStyles: { fillColor: false, textColor: [0, 0, 0] },
                columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // Salary Details
            doc.setFontSize(14);
            doc.text("Salary Details", 40, doc.lastAutoTable.finalY + 40);
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 50,
                head: [["No.of Days In Month", "Loss of Pay Days", "Days Payable", ""]],
                body: [[emp.totalDaysInMonth, emp.absentDays, emp.payableDays, " "]],
                headStyles: { fillColor: false, textColor: [128, 128, 128], fontStyle: "bold" },
                bodyStyles: { fillColor: false, textColor: [0, 0, 0] },
                //columnStyles: columnStyles,
                tableWidth: "auto",
            });

            // Earnings & Contributions Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 20,
                head: [["EARNINGS", "", "EMPLOYER CONTRIBUTION", ""]],
                body: [
                    ["Basic", formatNumber(emp.calculatedBasicSalary), "EPF", formatNumber(emp.calculatedEmployerEpf)],
                    ["Conveyance Allowance", formatNumber(emp.calculatedConveyance), "ESI", formatNumber(emp.calculatedEmployerEsi) || '-'],
                    ["HRA", formatNumber(emp.calculatedHra), "Total Contributions (B)", formatNumber(((emp.calculatedEmployerEpf || 0) + (emp.calculatedEmployerEsi || 0)))],
                    ["Medical Allowance", emp.calculatedMedicalAllowance, "EMPLOYEE DEDUCTIONS", ""],
                    ["Special Allowance", formatNumber(emp.calculatedOtherAllowance), "EPF", formatNumber(emp.calculatedEpf) || '-'],
                    ["Total Earnings (A)", formatNumber(emp.calculatedGrossSalary) || '-', "ESI", emp.calculatedEsi || '-'],
                    [" ", " ", "Professional Tax", emp.calculatedPt],
                    [" ", " ", "TPDS", formatNumber(emp.tpds) || '-'],
                    [" ", " ", "Total Deductions (C)", formatNumber(emp.calculatedTotalDeductions)],
                    // ✅ Net Salary Payable in same alignment
                    ["Net Salary Payable", formatNumber(emp.calculatedNetSalary), " ", " "],


                ],
                headStyles: { fillColor: false, textColor: [128, 128, 128], fontStyle: "bold" },
                bodyStyles: { fillColor: false, textColor: [0, 0, 0] },
                columnStyles: {
                    0: { halign: "left" },    // Earning labels
                    1: { halign: "right" },  // Earning values
                    2: { halign: "left" },    // Contribution/Deduction labels
                    3: { halign: "right" },  // Contribution/Deduction values
                },
                didParseCell: (data) => {
                    const boldBlack = ["Total Earnings (A)", "Total Contributions (B)", "Total Deductions (C)"];
                    if (boldBlack.includes(data.cell.raw)) {
                        data.cell.styles.fontStyle = "bold";
                        data.cell.styles.textColor = [0, 0, 0];
                    }
                    const sectionHeaders = ["EMPLOYEE DEDUCTIONS"];
                    if (sectionHeaders.includes(data.cell.raw)) {
                        data.cell.styles.fontStyle = "bold";
                        data.cell.styles.textColor = [128, 128, 128];
                    }
                },
            });

            // Net Salary In Words Table
            doc.autoTable({
                startY: doc.lastAutoTable.finalY,
                body: [
                    [
                        "Net Salary in words",
                        emp.calculatedNetSalary
                            ? toWords(emp.calculatedNetSalary)
                                .replace(/,/g, "")            // remove commas
                                .replace(/-/g, " ")          // replace hyphens with space
                                .replace(/\b\w/g, (c) => c.toUpperCase()) // capitalize
                                .replace(/\s*Only$/i, "")     // remove trailing "Only"
                            : "Invalid Salary",
                    ],
                ],
                headStyles: {
                    fillColor: false,
                    textColor: [128, 128, 128],
                    fontStyle: "bold",
                },
                bodyStyles: {
                    fillColor: false,
                    textColor: [0, 0, 0],
                },
                columnStyles: {
                    0: { halign: "left" }, // static label stays normal
                    1: { halign: "left", cellPadding: { left: 73 } }, // 🔹 shift only dynamic value a bit
                },
                didParseCell: (data) => {
                    if (data.column.index === 1) { // 🔹 only affect dynamic value column
                        data.cell.styles.fontStyle = "bold";
                        data.cell.styles.textColor = [0, 0, 0];
                    }
                },
            });

            // Footer Note
            const footerY = doc.lastAutoTable.finalY + 40;
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(0, 0, 0);
            doc.text("**Note : All amounts displayed in this payslip are in INR", 40, footerY);
            doc.text("*This is computer generated statement, does not require signature.", 40, footerY + 15);
        });

        doc.save("Salary_Slips.pdf");
    };

    return (
        <div className="roll-process-report-container">
            <div className="roll-process-report-box">
                <h2 className="roll-process-report-heading">Employee Payslip Generation</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleGenerateReport}
                >
                    <div className="roll-process-report-maincontainer">
                        <div className="roll-process-report-container-part">
                            <div className={`roll-process-report-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="roll-process-report-container-part">
                            <div className={`roll-process-report-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="roll-process-report-maincontainer">
                        <div className="roll-process-report-container-part">
                            <div className={`roll-process-report-floating-label-container ${isFocused.employee || employee ? 'float-label' : ''}`}>
                                <Select
                                    name="employee"
                                    options={employeeOptions}
                                    value={employeeOptions.find(opt => opt.value === employee) || null}
                                    onChange={option => handleInputChange(option, 'employee')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employee: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employee: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Employee Name</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="roll-process-report-container-part">
                            <div className={`roll-process-report-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="designation"
                                    value={designation || ""}
                                    onChange={(e) => {
                                        setDesignation(e.target.value);
                                        setErrors(prev => ({ ...prev, designation: null }));
                                    }}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, designation: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, designation: false }))}
                                    placeholder=" "
                                    className="did-floating-input"
                                    readOnly
                                />
                                <label>Designation</label>
                                {errors.designation && <div className="error-message">{errors.designation}</div>}
                            </div>

                        </div>
                    </div>
                    <div className="roll-maincontainer">

                        {/* From Date */}
                        <div className="roll-container-part">
                            <div className={`roll-floating-label-container-2 ${isFocused.fromDate || fromDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={fromDate ? new Date(fromDate) : null}
                                    onChange={(date) => {
                                        if (date) {
                                            const localDate = new Date(date);
                                            localDate.setHours(0, 0, 0, 0);
                                            const formatted = localDate.toLocaleDateString("en-CA");
                                            setFromDate(formatted);
                                        } else {
                                            setFromDate("");
                                        }
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="dd-MM-yyyy"
                                    className="did-floating-input"
                                    onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                                    ref={dateInputRef}
                                    maxDate={toDate ? new Date(toDate) : null} // prevents selecting after "To"
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={35}
                                />
                                <label>
                                    <span className="required">*</span>From Date (DD-MM-YYYY)
                                </label>
                                {errors.fromDate && <div className="error-message">{errors.fromDate}</div>}
                            </div>
                        </div>

                        {/* To Date */}
                        <div className="roll-container-part">
                            <div className={`roll-floating-label-container-2 ${isFocused.toDate || toDate ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={toDate ? new Date(toDate) : null}
                                    onChange={(date) => {
                                        if (date) {
                                            const localDate = new Date(date);
                                            localDate.setHours(0, 0, 0, 0);
                                            const formatted = localDate.toLocaleDateString("en-CA");
                                            setToDate(formatted);
                                        } else {
                                            setToDate("");
                                        }
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="dd-MM-yyyy"
                                    className="did-floating-input"
                                    onFocus={() => setIsFocused(prev => ({ ...prev, toDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, toDate: false }))}
                                    ref={dateInputRef}
                                    minDate={fromDate ? new Date(fromDate) : null} // prevents selecting before "From"
                                    maxDate={new Date()}
                                    showYearDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={35}
                                />
                                <label>
                                    <span className="required">*</span>To Date (DD-MM-YYYY)
                                </label>
                                {errors.toDate && <div className="error-message">{errors.toDate}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="roll-process-report-btn-div">
                        <button type="submit" className="roll-process-report-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>

            <div className="roll-process-table-container">
                {/* <button
                                className="download-excel-btn"
                                onClick={downloadExcel}
                            >
                                Download Excel
                            </button> */}


                {attendanceData && attendanceData.length > 0 ? (
                    <>
                        <button
                            className="download-roll"
                            onClick={downloadPDF}
                        >
                            Download PDF
                        </button>
                        {attendanceData.map((emp, index) => (
                            <div key={index} className="payslip-wrapper">

                                <React.Fragment key={index}> {/* Use a unique key */}
                                    <div className='roll-process-title'>
                                        <div >
                                            {emp.fullName || "Employee"}
                                        </div>
                                        <div>
                                            {`${monthNames[emp.month - 1]}-${emp.year}`}
                                        </div>
                                    </div>



                                    <table className="roll-process-table">
                                        <thead>
                                            <tr>
                                                <th>Employee Number</th>
                                                <th>Date Joined</th>
                                                <th>Location</th>
                                                <th>Designation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{emp.employeeId}</td>
                                                <td>{emp.joiningDate}</td>
                                                <td>{emp.districtName || '-'}</td>
                                                <td>{emp.designation}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table className="roll-process-table">
                                        <thead>
                                            <tr>
                                                <th>Bank</th>
                                                <th>IFSC Code</th>
                                                <th>Account Number</th>
                                                <th>Payment Mode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{emp.bankName}</td>
                                                <td>{emp.ifscCode}</td>
                                                <td>{emp.accountNumber}</td>
                                                <td>Bank Transfer</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table className="roll-process-table">
                                        <thead>
                                            <tr>
                                                <th>PAN</th>
                                                <th>UAN</th>
                                                <th>Member ID</th>
                                                <th>ESIC No</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{emp.panNumber}</td>
                                                <td>{emp.uanNumber}</td>
                                                <td>{emp.memberId}</td>
                                                <td>{emp.esiNumber}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <h3 className='roll-process-title'>Salary Details</h3>
                                    <table className="roll-process-table">
                                        <thead>
                                            <tr>
                                                {/* <th>Payable Days</th> */}
                                                <th>Total Working Days</th>
                                                <th>Loss of Pay Days</th>
                                                <th colSpan={2}>Days Payable</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {/* <td>{emp.payableDays}</td> */}
                                                <td>{emp.totalDaysInMonth}</td>
                                                <td>{emp.absentDays}</td>
                                                <td colSpan={2}>{emp.payableDays}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <br />

                                    <table className="roll-process-table">
                                        <thead className="roll-process-main-header">
                                            <tr>
                                                <th colSpan="2">EARNINGS</th>
                                                <th colSpan="2">EMPLOYER CONTRIBUTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Basic</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedBasicSalary)}</td>
                                                <td>EPF</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedEmployerEpf)}</td>
                                            </tr>
                                            <tr>
                                                <td>Conveyance Allowance</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedConveyance)}</td>
                                                <td>ESI</td>
                                                <td className="roll-value">{emp.calculatedEmployerEsi || '-'}</td>
                                                {/* <td className="roll-process-cell">Total Contributions (B)</td>
                                                    <td>{emp.totalContributions||'-'}</td> */}
                                            </tr>
                                            <tr>
                                                <td>HRA</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedHra)}</td>
                                                <td className="roll-process-cell">Total Contributions (B)</td>
                                                <td className="roll-value">
                                                    {formatNumber(((emp.calculatedEmployerEpf || 0) + (emp.calculatedEmployerEsi || 0)))}
                                                </td>
                                                {/* <td className="roll-process-cell" colSpan="2">TAXES & DEDUCTIONS</td> */}
                                            </tr>
                                            <tr>
                                                <td>Medical Allowance</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedMedicalAllowance)}</td>
                                                <th className="roll-process-cell" colSpan="2">EMPLOYEE DEDUCTIONS</th>

                                            </tr>
                                            <tr>
                                                <td>Special Allowance</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedOtherAllowance)}</td>
                                                <td>EPF</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedEpf)}</td>


                                            </tr>
                                            <tr>
                                                <td className="roll-process-cell">Total Earnings (A)</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedGrossSalary) || '-'}</td>
                                                <td>ESI</td>
                                                <td className="roll-value">{emp.calculatedEsi || '-'}</td>


                                            </tr>

                                            <tr>
                                                <td colSpan="2"></td>
                                                <td>Professional Tax</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedPt)}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2"></td>
                                                <td>TDS</td>
                                                <td className="roll-value">{emp.tds || '-'}</td>

                                            </tr>
                                            <tr>
                                                <td colSpan="2"></td>

                                                <td className="roll-process-cell">Total Deductions (C)</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedTotalDeductions)}</td>

                                            </tr>
                                        </tbody>
                                    </table>

                                    <table className="roll-process-table">
                                        <tbody>
                                            <tr>
                                                <td>Net Salary Payable</td>
                                                <td className="roll-value">{formatNumber(emp.calculatedNetSalary)}</td>
                                                <td colSpan="2"></td>
                                            </tr>
                                            <tr>
                                                <td>Net Salary in words</td>
                                                <td className="roll-process-cell" colSpan="3">
                                                    {emp.calculatedNetSalary
                                                        ? toWords(emp.calculatedNetSalary).replace(/\b\w/g, char => char.toUpperCase())
                                                        : 'Invalid Salary'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            </div>
                        ))}
                    </>
                ) : (
                    <p className="data-message">No data available.</p> // Fallback if `attendanceData` is empty
                )}
            </div>
        </div>
    );
};

export default EmployeePayrollsProcess;